import { SvgIcon, type SvgIconProps } from '@components/primitives/SvgIcon';

import Download from '../assets/icons/feather/Download.svg?react';

export function DownloadIcon(props: SvgIconProps) {
  return <SvgIcon component={Download} inheritViewBox {...props} />;
}
